import { render } from "./EmployeeRequests.vue?vue&type=template&id=3ffe1205"
import script from "./EmployeeRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__